var map = {
	"./arrow.png": 414,
	"./club.svg": 415,
	"./dice.svg": 416,
	"./eeziepay.svg": 417,
	"./fcl.svg": 418,
	"./fpx-logo.svg": 419,
	"./global-language.svg": 420,
	"./ifm-logo.svg": 421,
	"./modal-bg.jpg": 422,
	"./no-records.png": 423,
	"./pagcor.svg": 424,
	"./tether.svg": 425,
	"./x33-logo.png": 426
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;